"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNativeEyedropper = exports.supportNativeEyedropper = void 0;
function supportNativeEyedropper() {
    return typeof EyeDropper === 'function';
}
exports.supportNativeEyedropper = supportNativeEyedropper;
function useNativeEyedropper() {
    var eyeDropper = new EyeDropper();
    return eyeDropper.open();
}
exports.useNativeEyedropper = useNativeEyedropper;
